import {
  deleteData,
  getData,
  getDataforUrl,
  postFormData,
  putFormData,
} from "./index";

// Plans API
export const plansList = async (payload) => {
  return getData("subscription/plans", payload).then((data) => {
    return data;
  });
};

export const getPlanDetails = async (payload) => {
  return getDataforUrl("subscription/plans", payload).then((data) => {
    return data;
  });
};

export const createPlan = async (payload) => {
  return postFormData("subscription/plans", payload).then((data) => {
    return data;
  });
};

export const updatePlan = async (id, payload) => {
  return putFormData(`subscription/plans/${id}`, payload).then((data) => {
    return data;
  });
};

export const deletePlan = async (id) => {
  return deleteData(`subscription/plans/${id}`, {}).then((data) => {
    return data;
  });
};

// Addons API
export const addonsList = async (payload) => {
  return getData("subscription/addons", payload).then((data) => {
    return data;
  });
};

export const getAddonDetails = async (payload) => {
  return getDataforUrl("subscription/addons", payload).then((data) => {
    return data;
  });
};

export const createAddon = async (payload) => {
  return postFormData("subscription/addons", payload).then((data) => {
    return data;
  });
};

export const updateAddon = async (id, payload) => {
  return putFormData(`subscription/addons/${id}`, payload).then((data) => {
    return data;
  });
};

export const deleteAddon = async (id) => {
  return deleteData(`subscription/addons/${id}`, {}).then((data) => {
    return data;
  });
};
